(function( $ ) {
		'use strict';

		ready( checkIfSOPHashExists() );

		/**
		 * Detect if doc is ready and fire func inside
		 *
		 * @param fn
		 */
		function ready( fn ) {
			if ( document.attachEvent
			     ? document.readyState === 'complete'
			     : document.readyState !== 'loading' ) {
				fn();
			} else {
				document.addEventListener( 'DOMContentLoaded', fn );
			}
		}

		function checkIfSOPHashExists() {
			//don't run if we're not on the Collateral SOPs page
			if ( document.body.classList ) {
				if ( !document.body.classList.contains( 'page-template-page-collateral-sops' ) ) {
					return;
				}
			}

			//If page has hash already in url On Load
			if ( location.hash ) {
				let expandBtns = document.querySelectorAll( '.btn-section-toggle' ),
				    i;

				for ( i = 0; i < expandBtns.length; ++i ) {
					if ( expandBtns[ i ].classList.contains( 'glyphicon-plus' ) ) {
						expandBtns[ i ].click();
					}
				}

				setTimeout( function() {
					$( 'html, body' )
						.scrollTop( $( window.location.hash ).offset().top );
				}, 1 );
			}

			$( '#sop-collapsible-sections a:not(.btn-anchor-to-top)' ).on( 'click', function( e ) {
				expandAllCollateralSectionsOnJump( e );
			} );
		}

		function expandAllCollateralSectionsOnJump( e ) {
			e.preventDefault();
			let currentUrl = e.target.getAttribute( 'href' );

			if ( currentUrl.indexOf( '#' ) === -1 ) {
				//if the url does not have a hash, go to link as usual
				window.location.href = currentUrl;
			} else {
				let urlSplit   = currentUrl.split( '#' ),
				    hashString = urlSplit[ urlSplit.length - 1 ];

				if ( hashString ) {
					let expandBtns = document.querySelectorAll( '.btn-section-toggle' );
					for ( let i = 0; i < expandBtns.length; ++i ) {
						if ( expandBtns[ i ].classList.contains( 'glyphicon-plus' ) ) {
							expandBtns[ i ].click();
						}
					}
					// Delay added to wait for the sections to expand
					setTimeout( function() {
						scrollToSection( hashString );
					}, 300 ); // delay in milliseconds
				}
			}
		}

		function scrollToSection( hashString ) {
			let targetElement = $( '#' + hashString );
			if ( targetElement.is( ':visible' ) ) {
				$( 'html, body' ).animate( {
					                           scrollTop: targetElement.offset().top
				                           }, 300 ); // Smooth scroll
			}
		}
	}
)( jQuery );